export const Constants = {
  TAG_NAME: 'pop-pc-chip-component',
  EVENTS: {
    CLOSE_CHIP: 'close-chip',
  },
  CLOSE_CHIP_FILTER_ARIA_LABEL: 'Remove ${content} button',
  BUTTON_TYPE: 'BTN',
};
